import { Component, OnInit,Input } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit {

  @Input() data

  localData: any = {}
  displayName: any 
  constructor(
    private router: Router
  ) { 
    
  }

  ngOnInit() {
    console.log('%cDashboard module', "color: red;")
    this.localData = JSON.parse(localStorage.getItem('user-details'))
    // Extract first name from full name
    let nameArray = this.localData.display_name.split(' ')
    this.displayName = nameArray[0]
  }

  redirectToPage(url){
    this.router.navigateByUrl(url);
  }

}

